export default __webpack_public_path__ + "static/media/news2.79d6b5ec.webp";